export const tabs = [
  { label: 'Правила', key: 'rules' },
  { label: 'Журнал', key: 'decisions' },
  { label: 'На проверке', key: 'review' },
  { label: 'Ограничения', key: 'targets' },
];
export const defaultNoticeText =
  '{name}, ваше сообщение похоже на рекламное. Оплатите размещение: @cosmom_ru';
export function noticeTextError(text) {
  if (
    typeof text !== 'string' ||
    !text.trim() ||
    [...text.trim()].length > 1000
  )
    return 'Введите текст от 1 до 1000 символов.';
  if (
    [...text].some(character => {
      const code = character.codePointAt(0);
      return code < 32 && ![9, 10, 13].includes(code);
    })
  )
    return 'Удалите управляющие символы из текста.';
  if ((text.match(/\{[^{}]*\}/g) || []).some(value => value !== '{name}'))
    return 'Поддерживается только подстановка {name} — имя автора.';
  return '';
}
export const labels = {
  waiting_member: 'Ожидает вступления в группу',
  off: 'Выключена',
  trial: 'Пробный режим',
  enforce: 'Рабочий режим',
  pending: 'Проверка отправителя',
  review: 'Нужно решение',
  violation: 'Нарушение',
  allow: 'Разрешено',
  exempt: 'Исключение',
  cancelled: 'Отменено',
  queued: 'В очереди',
  attempting: 'Выполняется',
  succeeded: 'Выполнено',
  failed: 'Не выполнено',
  unknown: 'Результат не подтверждён',
  restored: 'Ограничение снято',
  restore_queued: 'Ожидает снятия',
  duplicate: 'Точный повтор за час',
  notice: 'Уведомление',
  shown: 'Показано',
  expired: 'Срок истёк',
  cleared: 'Показано и удалено',
  suppressed: 'Пропущено: в группе уже показано уведомление',
  fast_job_offer: 'Посторонняя работа или оплачиваемое поручение',
  fast_cash_offer: 'Предложение заработка или займа',
  fast_microtask_offer: 'Оплата отзывов и других цифровых заданий',
  fast_drug_offer: 'Предложение наркотических проб или торговли',
  paid_review_offer: 'Оплата за отзывы',
  money_standalone: 'Сумма без контекста',
  money_earnings_offer: 'Сумма в предложении посторонней работы или заработка',
  money_context_missing: 'Не удалось подтвердить контекст ответа с суммой',
  money_ambiguous: 'Неоднозначное сообщение с суммой',
  service_price: 'Обсуждение стоимости бьюти-услуг',
  ordinary_message: 'Обычное сообщение',
  stop_word: 'Запрещённая фраза',
  suspicious_phrase: 'Подозрительное предложение — нужна проверка',
  advertising_review: 'Возможное объявление — нужна проверка',
  album_violation: 'Часть альбома с подтверждённым нарушением',
  unknown_media: 'Неизвестный тип вложения',
  contact: 'Ссылка или контакт',
  media: 'Запрещённое медиа',
  forward: 'Пересланное сообщение',
  semantic_review: 'Нужна проверка смысла',
  semantic_spam: 'ИИ: подтверждённый спам',
  semantic_offtopic: 'ИИ: сообщение вне темы группы',
  identity_pending: 'Проверка отправителя',
  identity_unconfirmed: 'Отправитель не подтверждён',
  owned_or_admin: 'Наш аккаунт или администратор',
  paid_publication: 'Разрешённая публикация',
  paid_publication_trial: 'Разрешённая публикация (пробный режим)',
  paid_publication_review:
    'Объявление ожидает подтверждения, размещение в резерве',
  cutover_window: 'Сообщение переходного окна — требуется сверка',
  legacy_paid_publication: 'Уже учтено в старой системе',
  paid_safety_review: 'Оплаченный материал требует проверки безопасности',
  paid_permission_pending: 'Нужно уточнить право или доступный остаток',
  operator_ordinary: 'Обычная переписка — без списания',
  placements_disabled: 'Учёт размещений выключен',
  metadata_missing: 'Недостаточно данных',
  operator_decision: 'Решение администратора',
  configuration_changed: 'Настройки изменились',
  identity_or_original_unknown: 'Требуется уточнение публикации',
  delete: 'Удаление',
  restrict: 'Запрет писать',
  restore: 'Снятие запрета',
};
export function parseOwnedIds(value) {
  const parts = value.split(/[\s,]+/).filter(Boolean);
  if (
    parts.length > 100 ||
    parts.some(
      id => !/^[1-9]\d{0,15}$/.test(id) || !Number.isSafeInteger(Number(id))
    )
  ) {
    throw new Error(
      'Укажите до 100 корректных Telegram ID, разделённых пробелами или запятыми.'
    );
  }
  return [...new Set(parts.map(Number))];
}
export function errorMessage(error) {
  const status = error?.response?.status;
  return (
    {
      403: 'Этот раздел доступен только администратору.',
      401: 'Сессия завершилась. Войдите в систему и обновите раздел.',
      404: 'Модуль модерации пока недоступен.',
      409: 'Данные изменились или действие недоступно. Обновите список перед повтором.',
      500: 'Сервер не смог загрузить раздел. Повторите загрузку позже.',
      502: 'Сервер временно недоступен. Повторите загрузку позже.',
      503: 'Сервер временно недоступен. Повторите загрузку позже.',
      504: 'Сервер не ответил вовремя. Повторите загрузку.',
    }[status] ||
    (error?.code === 'ECONNABORTED'
      ? 'Не дождались ответа сервера. Проверьте соединение и повторите загрузку.'
      : 'Не удалось связаться с сервером. Проверьте соединение. Если сохраняли изменения — обновите данные перед повтором.')
  );
}

export const moderationMediaTypes = [
  'photo',
  'video',
  'animation',
  'video_note',
  'voice',
  'audio',
  'document',
];
export function effectiveGroupRule(rule = {}) {
  return {
    mode: 'off',
    contacts: true,
    media: true,
    forwards: true,
    duplicates: true,
    money_spam: false,
    stop_words: [],
    review_phrases: [],
    action: 'delete',
    warning_limit: 4,
    restriction_seconds: 86400,
    blocked_media: [...moderationMediaTypes],
    ...rule,
  };
}
export function commonGroupRule(rules) {
  if (!rules.length) return null;
  return Object.fromEntries(
    Object.keys(effectiveGroupRule()).map(key => {
      const first = rules[0][key];
      return [
        key,
        rules.every(rule => JSON.stringify(rule[key]) === JSON.stringify(first))
          ? first
          : undefined,
      ];
    })
  );
}
// Keep absent rules absent unless explicitly edited. Never spread one group's
// settings over others; the server still validates tenant, version and all rules.
export function applyGroupEdits(groups, ids, changes, mediaChanges = {}) {
  const result = JSON.parse(JSON.stringify(groups || {}));
  if (!Object.keys(changes).length && !Object.keys(mediaChanges).length)
    return result;
  ids.forEach(id => {
    const original = groups?.[id] || {};
    const rule = { ...original, ...changes };
    if (Object.keys(mediaChanges).length) {
      const selected = new Set(effectiveGroupRule(original).blocked_media);
      Object.entries(mediaChanges).forEach(([type, blocked]) => {
        if (blocked) selected.add(type);
        else selected.delete(type);
      });
      rule.blocked_media = moderationMediaTypes.filter(type =>
        selected.has(type)
      );
    }
    result[id] = rule;
  });
  return result;
}

// Mirror Settings.validate and Rules.normalize without changing moderation semantics.
export function wordListError(text, key = 'stop_words') {
  const lines = text
    .split('\n')
    .map((value, index) => ({ value: value.trim(), line: index + 1 }))
    .filter(item => item.value);
  if (new Set(lines.map(item => item.value)).size > 100)
    return 'Не более 100 слов или фраз в одном списке.';
  return (
    lines
      .map(({ value, line }) => {
        const normalized = value
          .normalize('NFKC')
          .toLowerCase()
          .replace(/ё/g, 'е')
          .replace(/[\u200B-\u200F\uFEFF]/g, '')
          .replace(/[^\p{L}\p{N}\s]/gu, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        const literalSymbol =
          key === 'stop_words' && /^[\p{P}\p{S}]+$/u.test(value);
        if (
          [...value].length > 80 ||
          (!literalSymbol &&
            ([...value].length < 2 || [...normalized].length < 2))
        )
          return key === 'stop_words'
            ? `Строка ${line}: введите слово или фразу от 2 до 80 символов либо знак, например $. Пробелы и невидимые символы не подходят.`
            : `Строка ${line}: введите слово или фразу от 2 до 80 символов. Знаки поддерживаются только в стоп-словах.`;
        return '';
      })
      .find(Boolean) || ''
  );
}
